import React from 'react';
import classNames from 'classnames';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IProps {
  isChecked: boolean;
  text: string;
  onClick: () => void;
  className?: string;
}

const Checkbox = ({ isChecked, text, onClick, className }: IProps) => {
  return (
    <button
      onClick={onClick}
      className={classNames(css.checkbox, {
        [css.isChecked]: isChecked,
      }, className)}
    >
      {isChecked && (
        <div className={css.checkbox__mark}>
          <Icon id="18--check-mark" />
        </div>
      )}
      <div className={css.checkbox__text}>{text}</div>
    </button>
  );
};

export default Checkbox;
